import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-test-mode",
  "use": "foquz-icon-test-mode-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol viewBox=\"0 0 21 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-test-mode\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.5 21C16.299 21 21 16.299 21 10.5S16.299 0 10.5 0 0 4.701 0 10.5 4.701 21 10.5 21zm-3-15a1.5 1.5 0 100 3H9v6a1.5 1.5 0 003 0V9h1.5a1.5 1.5 0 000-3h-6z\" fill=\"#F96261\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol